<template>
  <div>
    <div :style="{ maxHeight: showTags ? '' : '200px', overflow: showTags ? 'block' : 'hidden' }">
      <template v-if="value.length > 0">
        <v-chip
          v-for="(count, index) in tags"
          :key="'tag_' + index"
          small
          outline
          color="primary"
          disabled
          >{{ index }}{{ count > 1 ? ` (${count})` : '' }}</v-chip
        >
      </template>
      <div v-else class="primary--text">-</div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      showTags: false
    }
  },
  computed: {
    tags() {
      return this.value
        ? this.value.reduce((prev, curr) => {
            if (Object.prototype.hasOwnProperty.call(prev, curr)) {
              prev[curr]++
            } else {
              prev[curr] = 1
            }
            return prev
          }, {})
        : {}
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/ecommerce/TagGroup.vue